import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function RecipeFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cuisine, setCuisine] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedRecipe(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedRecipe(null);
  };

  const cuisines = [
    { id: "all", name: "Todas" },
    { id: "brazilian", name: "Brasileira" },
    { id: "italian", name: "Italiana" },
    { id: "japanese", name: "Japonesa" },
    { id: "mexican", name: "Mexicana" },
    { id: "chinese", name: "Chinesa" },
    { id: "dessert", name: "Sobremesas" },
    { id: "vegan", name: "Vegana" },
    { id: "fitness", name: "Fitness" },
  ];

  const difficulties = {
    easy: "Fácil",
    medium: "Médio",
    hard: "Difícil",
  };

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/recipe?page=${pageNum}&limit=12`;
      if (cuisine !== "all") url += `&cuisine=${cuisine}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching recipe:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [cuisine]);

  if (loading && posts.length === 0) {
    return <div className="recipe_feed_loading"><div className="recipe_loader"></div><span>Carregando receitas...</span></div>;
  }

  return (
    <div className="recipe_feed">
      {cuisines.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {cuisines.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${cuisine === filter.id ? "active" : ""}`}
                onClick={() => setCuisine(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="recipe_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>
          </svg>
          <h3>Nenhuma receita encontrada</h3>
          <p>Compartilhe sua receita!</p>
        </div>
      ) : (
        <div className="recipe_grid">
          {posts.map((post) => (
            <div key={post._id} className="recipe_card" onClick={() => setSelectedRecipe(post)}>
              <div className="recipe_card_image">
                <img src={post.recipeData?.photo || post.images?.[0]?.url || post.images?.[0] || "/images/default-recipe.png"} alt="" />
                <span className={`recipe_difficulty ${post.recipeData?.difficulty || "easy"}`}>
                  {difficulties[post.recipeData?.difficulty] || "Fácil"}
                </span>
              </div>
              <div className="recipe_card_content">
                <span className="recipe_cuisine">
                  {cuisines.find(c => c.id === post.recipeData?.cuisine)?.name || "Receita"}
                </span>
                <h3>{post.recipeData?.title || post.text}</h3>
                <div className="recipe_times">
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                    </svg>
                    Preparo: {post.recipeData?.prepTime || 0} min
                  </span>
                  <span>
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67z"/>
                    </svg>
                    Cozimento: {post.recipeData?.cookTime || 0} min
                  </span>
                </div>
                <div className="recipe_footer">
                  <span className="recipe_servings">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                    </svg>
                    {post.recipeData?.servings || 0} porções
                  </span>
                  <Link to={`/profile/${post.user.username}`} className="recipe_author" onClick={(e) => e.stopPropagation()}>
                    <img src={post.user.picture} alt="" />
                  </Link>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="recipe_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais receitas"}
          </button>
        </div>
      )}

      {selectedRecipe && (
        <div className="recipe_modal_overlay" onClick={() => setSelectedRecipe(null)}>
          <div className="recipe_modal" onClick={(e) => e.stopPropagation()}>
            <button className="recipe_modal_close" onClick={() => setSelectedRecipe(null)}>✕</button>

            <div className="recipe_modal_header">
              <img src={selectedRecipe.recipeData?.photo || selectedRecipe.images?.[0]} alt="" />
            </div>

            <div className="recipe_modal_body">
              <div className="recipe_modal_meta">
                <span className="recipe_modal_cuisine">
                  {cuisines.find(c => c.id === selectedRecipe.recipeData?.cuisine)?.name}
                </span>
                <span className={`recipe_modal_difficulty ${selectedRecipe.recipeData?.difficulty || "easy"}`}>
                  {difficulties[selectedRecipe.recipeData?.difficulty] || "Fácil"}
                </span>
              </div>
              <h2>{selectedRecipe.recipeData?.title}</h2>

              <div className="recipe_modal_stats">
                <div className="recipe_stat">
                  <span className="recipe_stat_value">{selectedRecipe.recipeData?.prepTime || 0}</span>
                  <span className="recipe_stat_label">min preparo</span>
                </div>
                <div className="recipe_stat">
                  <span className="recipe_stat_value">{selectedRecipe.recipeData?.cookTime || 0}</span>
                  <span className="recipe_stat_label">min cozimento</span>
                </div>
                <div className="recipe_stat">
                  <span className="recipe_stat_value">{selectedRecipe.recipeData?.servings || 0}</span>
                  <span className="recipe_stat_label">porções</span>
                </div>
              </div>

              {selectedRecipe.recipeData?.dietary?.length > 0 && (
                <div className="recipe_dietary">
                  {selectedRecipe.recipeData.dietary.map((d, i) => (
                    <span key={i}>{d}</span>
                  ))}
                </div>
              )}

              {selectedRecipe.recipeData?.ingredients?.length > 0 && (
                <div className="recipe_modal_section">
                  <h4>Ingredientes</h4>
                  <ul className="recipe_ingredients_list">
                    {selectedRecipe.recipeData.ingredients.map((ing, i) => (
                      <li key={i}>
                        <span className="recipe_ing_amount">{ing.amount}</span>
                        <span className="recipe_ing_name">{ing.name}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedRecipe.recipeData?.steps?.length > 0 && (
                <div className="recipe_modal_section">
                  <h4>Modo de preparo</h4>
                  <ol className="recipe_steps_list">
                    {selectedRecipe.recipeData.steps.map((step, i) => (
                      <li key={i}>
                        <span className="recipe_step_number">{i + 1}</span>
                        <span className="recipe_step_text">{step}</span>
                      </li>
                    ))}
                  </ol>
                </div>
              )}

              {selectedRecipe.recipeData?.nutrition && (
                <div className="recipe_modal_section">
                  <h4>Informação nutricional (por porção)</h4>
                  <div className="recipe_nutrition_grid">
                    <div className="recipe_nutrition_item">
                      <span className="recipe_nutrition_value">{selectedRecipe.recipeData.nutrition.calories || 0}</span>
                      <span className="recipe_nutrition_label">kcal</span>
                    </div>
                    <div className="recipe_nutrition_item">
                      <span className="recipe_nutrition_value">{selectedRecipe.recipeData.nutrition.protein || 0}g</span>
                      <span className="recipe_nutrition_label">proteína</span>
                    </div>
                    <div className="recipe_nutrition_item">
                      <span className="recipe_nutrition_value">{selectedRecipe.recipeData.nutrition.carbs || 0}g</span>
                      <span className="recipe_nutrition_label">carbos</span>
                    </div>
                    <div className="recipe_nutrition_item">
                      <span className="recipe_nutrition_value">{selectedRecipe.recipeData.nutrition.fat || 0}g</span>
                      <span className="recipe_nutrition_label">gordura</span>
                    </div>
                  </div>
                </div>
              )}

              <Link to={`/profile/${selectedRecipe.user.username}`} className="recipe_chef">
                <img src={selectedRecipe.user.picture} alt="" />
                <div>
                  <span className="recipe_chef_label">Chef</span>
                  <span className="recipe_chef_name">{selectedRecipe.user.first_name} {selectedRecipe.user.last_name}</span>
                </div>
              </Link>

              <button className="recipe_save_btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"/>
                </svg>
                Salvar receita
              </button>
            </div>
          </div>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
